import { configureStore } from "@reduxjs/toolkit";
import ChangePageSlice from "./slices/ChangePageSlice";
import FiltersRegistrationSlice from "./slices/FiltersRegistrationSlice";
import FiltersParticipantSlice from "./slices/FiltersParticipantSlice";
import FiltersInvoiceSlice from "./slices/FiltersInvoiceSlice";
import ChangeItemsPerPage from "./slices/ChangeItemsPerPage";

const store = configureStore({
  reducer: {
    changePage: ChangePageSlice,
    filterRegistration: FiltersRegistrationSlice,
    filterParticipant: FiltersParticipantSlice,
    filterInvoice: FiltersInvoiceSlice,
    changeItemsPerPage: ChangeItemsPerPage,
  },
});

export default store;
